<div class="row" *ngIf="comment && !isEditing" [ngClass]="{'d-none': comment && isEditing}">
  <div class="col mt-3 p-3 comment-text">
    <ng-container *ngTemplateOutlet="commentLabel"></ng-container>
    <div class="text-area-mask" [innerHTML]="comment"></div>
    <button class="btn-edit btn btn-outline-primary float-right" *ngIf="comment && !isEditing" (click)="updateExistingComment(textAreaElement)">
      {{ 'BUTTONS.EDIT' | translate }}
    </button>
  </div>
</div>

<div class="row" [ngClass]="{'d-none': comment && !isEditing}">
  <div class="col mt-3 p-3">
    <ng-container *ngTemplateOutlet="commentLabel"></ng-container>
    <textarea [placeholder]="'COMMENTS.COMMENT.PLACEHOLDER' | translate" name="" id="" rows="12" #textAreaElement autofocus></textarea>
    <button class="btn btn-tonal-primary mt-1 float-right" (click)="sendComment(textAreaElement)">
      {{ 'BUTTONS.UPDATE' | translate }}
    </button>
    <button *ngIf="comment" class="btn btn-secondary mt-1 mr-2 float-right" (click)="cancel()">
      {{ 'BUTTONS.CANCEL' | translate }}
    </button>
  </div>
</div>

<ng-template #commentLabel>
  <label *ngIf="label" class="form-label fw-bold mb-2 d-flex align-items-center gap-3">
    {{ label }}
    <span
      *ngIf="additionalInfo"
      class="material-icons help-icon fs-16 black-color"
      [ngbPopover]="additionalInfo"
      triggers="hover"
      placement="top"
    >
    </span>
  </label>
</ng-template>
